import { clearData } from "./clearData";
import { UserDexie } from "../interfaces/userDexie";

export async function addUsers(users: UserDexie[], thisUsers): Promise<void> {
    await clearData(thisUsers)
    await thisUsers.bulkPut(users);
}
